import styled from 'styled-components'

export const CellWithAvatar = styled.div(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  gap: theme.space['8'],
}))

export const CellTextWrapper = styled.div({
  display: 'flex',
  flexDirection: 'column',
  minWidth: 0,
})

// Note: Figma's "Emergency" urgency flag for the Submitted by cell (node 21273-4895) - a small
// circular icon badge, not the pill-shaped `Badge` component used for text badges elsewhere.
export const UrgentBadge = styled.div(({ theme }) => ({
  alignItems: 'center',
  backgroundColor: theme.colors.red500,
  borderRadius: '50%',
  color: theme.colors.white,
  display: 'flex',
  flexShrink: 0,
  height: '2.4rem',
  justifyContent: 'center',
  width: '2.4rem',
}))

// Note: EL-15428's "PMS Integration" mark for a work order a PMS sync raised - a building icon
// in a light-blue circle, sized like the avatar it stands in for so the rows line up.
export const PmsBadge = styled.div(({ theme }) => ({
  alignItems: 'center',
  backgroundColor: theme.colors.blue100,
  borderRadius: '50%',
  color: theme.colors.blue500,
  display: 'flex',
  flexShrink: 0,
  height: '3.2rem',
  justifyContent: 'center',
  width: '3.2rem',
}))

// Note: a single-line ellipsis on a plain block (not Typography's line clamp), so
// useIsTruncated can compare scrollWidth against clientWidth.
export const TruncatedText = styled.span({
  display: 'block',
  minWidth: 0,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
})
